import { endOfWeek, format, startOfWeek } from 'date-fns';

import Highcharts from 'plugins/highcharts/highcharts';
import Info from '@ds/icons/assets/DsIcon-Info.svg';
import { colorVariation, iconVariation, numberFormatToPtBr } from '@/utils';

export const formatterDateLabel = (date) => Highcharts.dateFormat('%d/%m', date);

const arrowIcon = (color, icon) => `
  <div 
    class="highcharts-custom-tooltip__ds-icon" 
    style="background: ${color}; 
    -webkit-mask-image: url(${icon});
    mask-image: url(${icon});"
  >
  </div>
`;

const variationTooltip = (value) => `
  <div class="highcharts-custom-tooltip__variation">
    ${value}
  </div>
`;

const variationWithPercent = ({ variation, percentVariation, color, icon }) => `
  <div class="highcharts-custom-tooltip__variation-grid">
    ${variationTooltip(variation)}

    ${arrowIcon(color, icon)}

    <div 
      class="highcharts-custom-tooltip__variation-value" 
      style="color: ${color}"
    >
      ${percentVariation}%
    </div>
  </div>
`;

export const getPointWrapper = (coordinate, config) => {
  const coordinateColor = coordinate.color;
  const coordinateSeriesName = coordinate.series.name;
  const coordinateYFormatted = numberFormatToPtBr(coordinate.y);

  const handleVariationTemplate = config.addPercentVariation
    ? variationWithPercent({
      variation: coordinateYFormatted,
      percentVariation: numberFormatToPtBr(coordinate.point.period_variation),
      color: colorVariation(coordinate.point.period_variation),
      icon: iconVariation(coordinate.point.period_variation),
    })
    : variationTooltip(coordinateYFormatted);

  return `
    <div class="highcharts-custom-tooltip__item-wrapper">
      <div class="highcharts-custom-tooltip__item">
        <div 
          class="highcharts-custom-tooltip__legend" 
          style="color:${coordinateColor};"
        >
          <span>${coordinateSeriesName}</span>
        </div>
      </div>

    ${handleVariationTemplate}
    </div>
  `;
};

const getPointList = (pointList, config) => {
  let pointsWrapper = '';

  pointList.forEach((point) => {
    pointsWrapper += getPointWrapper(point, config);
  });

  return pointsWrapper;
};

const headerTooltip = (text) => `
  <div class="highcharts-custom-tooltip__header">${text}</div>
`;

const dividerSectionTooltip = () => `
  <hr class="highcharts-custom-tooltip__divider">
`;

const footerTooltip = () => `
  ${dividerSectionTooltip()}

  <div class="highcharts-custom-tooltip__footer">
    <div 
      class="highcharts-custom-tooltip__ds-icon-info" 
      style="-webkit-mask-image: url(${Info}); mask-image: url(${Info});">
    </div>
    <p> 
      Variação em relação ao mesmo período (número de dias) no qual foi selecionado
    </p>
  </div>
`;

export const formatterTooltip = (coordinate, config) => {
  const handleWeekPeriod = (date) => {
    const formatDate = (d) => format(d, 'dd/LL/yyyy');

    const startDate = formatDate(startOfWeek(new Date(date)));
    const endDate = formatDate(endOfWeek(new Date(date)));

    return `${startDate} - ${endDate}`;
  };

  const handlePeriod = (dateFormat) => (date) => {
    return Highcharts.dateFormat(dateFormat, date);
  };

  const getDateByPeriod = {
    'DAY': handlePeriod('%A, %d/%m/%y'),
    'WEEK': handleWeekPeriod,
    'MONTH': handlePeriod('%B/%Y'),
  }[config.period](coordinate.x);

  return `
    <div class="highcharts-custom-tooltip"> 
      ${config.addHeader ? headerTooltip(getDateByPeriod) : ''}

      <div class="highcharts-custom-tooltip__content">
        ${getPointList(coordinate.points, config)}
      </div>
      
      ${config.addFooter ? footerTooltip() : ''}
    </div>
  `;
};

